import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { TiposAsistenciaPipe } from '../_pipes/tipos-asistencia.pipe';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { ReporteGeneralService } from './reporte-general.service';
import { map, startWith, tap } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { ListaAlumnosComponent } from '../lista-alumnos/lista-alumnos.component';
import { AsistenciaService } from '../_services/asistencia.service';
import { CursosService } from '../../../_services/cursos.service';
import { MY_FORMATS } from '../../../_models/moment-formats';
import { ThrobberService } from 'src/app/_services/throbber.service';
import { DynamicBarService } from 'src/app/_components/dynamic-bar/dynamic-bar.service';
import { FiltroIDPipe } from '../_pipes/filtro-id.pipe';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'asistencia-reporte-general',
  standalone: false,
  templateUrl: 'reporte-general.component.html',
  styleUrls: [
    '../asistencia.component.scss',
    './reporte-general.component.scss',
    '../../nivelaciones/citacion-materia-curso/citacion-materia-curso.component.scss'
  ],
  providers: [
    TiposAsistenciaPipe,
    FiltroIDPipe,
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  encapsulation: ViewEncapsulation.None
})

export class AsistenciaReporteGeneralComponent implements OnInit, OnDestroy {

  fechaSeleccionada = this.route.snapshot.paramMap.get('fecha') ?
    this.route.snapshot.paramMap.get('fecha') : moment().format('YYYY-MM-DD');

  allStudentsData$ = this.reporteGeneralService.allStudentesData$;

  listWarningDates = [];
  listWarningDates$ = this.reporteGeneralService.warningDates$
    .pipe(
      map(dates =>
        dates.map(date => {
          this.listWarningDates.push(moment(date.substring(0, 10)));
          return moment(date.substring(0, 10));
        })
      )
    );

  presencial = [
    { key: 'Todos', value: 0 },
    { key: 'Con autorización presencial', value: 1 },
    { key: 'Sin autorización presencial', value: 2 },
  ];

  private textFilterSubject = new BehaviorSubject('');
  textFilterAction$ = this.textFilterSubject.asObservable();
  private courseFilterSubject = new BehaviorSubject(0);
  courseFilterAction$ = this.courseFilterSubject.asObservable();

  novedadForm = new UntypedFormControl([]);

  presencialForm = new UntypedFormControl(0);

  cambiosSubscription: Subscription;

  tiposAsistencia = [];
  displayedColumns = ['Curso', 'Alumno', 'Acudientes', 'Estado', 'General', 'Observacion'];
  reportedStudents$ = combineLatest([
    this.textFilterAction$,
    this.courseFilterAction$,
    this.reporteGeneralService.reportedStudentsOp$,
    this.presencialForm.valueChanges.pipe(startWith(this.presencialForm.value)),
    this.novedadForm.valueChanges.pipe(startWith(this.novedadForm.value), tap(data => console.log(data)))
  ])
    .pipe(
      map(([textFilterValue, courseFilterValue, reportedStudents, presencialForm, novedadForm]) => {
        return reportedStudents.filter(reportedStudent => {
          return reportedStudent.alumno.apellidosNombres.toLowerCase().indexOf(textFilterValue) > -1
            && (courseFilterValue === 0 ? true : reportedStudent.curso.id === courseFilterValue) &&
            (presencialForm === 0 ||
              (presencialForm === 1 && reportedStudent.autorizaciones.findIndex(item => item.tipoOrigen === 301) > -1)
              || (presencialForm === 2 && reportedStudent.autorizaciones.findIndex(item => item.tipoOrigen === 301) === -1)) &&
            (novedadForm.length === 0 || novedadForm.findIndex(item => item === reportedStudent.asistencia.tipoID) > -1);
        });
      })
    );

  cursos$ = this.cursosService.cursos$;

  subComment;

  date = new UntypedFormControl(moment(this.fechaSeleccionada));
  dateClass = (d: Date) => {
    const date = moment(d).format('YYYY-MM-DD');
    return this.listWarningDates.findIndex(pendienteDate =>
      pendienteDate.format('YYYY-MM-DD').indexOf(date) > -1) > -1 ? 'warning-date' : undefined;
  };

  constructor (
    private title: Title,
    private dynamicBar: DynamicBarService,
    private route: ActivatedRoute,
    private router: Router,
    private matDialogRef: MatDialog,
    private cdRef: ChangeDetectorRef,
    private asistenciaService: AsistenciaService,
    private reporteGeneralService: ReporteGeneralService,
    private tipoAsistenciaPipe: TiposAsistenciaPipe,
    private cursosService: CursosService,
    private throbberService: ThrobberService,
  ) { }

  ngOnInit() {
    this.title.setTitle('Inicio/Asistencia Novedades');
    this.dynamicBar.setBarra('barra-simple', {
      titulos: [
        { texto: 'Inicio', link: ['/'] },
        { texto: 'Asistencia', link: [] },
        { texto: 'Novedades', link: [] },
      ],
    });
    this.reporteGeneralService.selectedDateChange(this.fechaSeleccionada);
    this.tiposAsistencia = this.route.parent.snapshot.data['tiposAsistencia'];
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnDestroy(): void {
    if (this.cambiosSubscription) {
      this.cambiosSubscription.unsubscribe();
    }
  }

  changeDate(date) {
    this.router.navigate(['/', 'asistencia', 'general', 'fecha', moment(date).format('YYYY-MM-DD')]);
  }

  filtroTexto(value) {
    this.textFilterSubject.next(value.toLowerCase());
  }

  filtroCurso(value) {
    this.courseFilterSubject.next(+value);
  }

  setAsistencia(tipoAsistencia, element) {
    element.asistencia.tipoID = tipoAsistencia.id;
    this.asistenciaService.setEstadoAsistencia(element.asistencia).subscribe(res => {
      element.asistencia = res['asistencia'];
    }, err => {
      console.error(err);
    }, () => {
    });
  }

  deleteAsistencia(alumno) {
    if (alumno.asistencia.isPermiso) {
      alumno.asistencia.tipoID = 12;
      this.asistenciaService.setEstadoAsistencia(alumno.asistencia).subscribe(res => {
        alumno.asistencia = res['asistencia'];
      }, err => {
        console.error(err);
      }, () => {
      });

    } else {
      this.asistenciaService.deleteAsistenciaAlumno(alumno.asistencia.id).subscribe(res => {
        if (alumno.asistenciasDia.length === 0) {
          this.reporteGeneralService.removeStudent(alumno);
        } else {
          if (alumno.asistencia.isPermiso) {
            alumno.asistencia.tipoID = 12;
          } else {
            alumno.asistencia.tipoID = 0;
            alumno.asistencia.id = 0;
            alumno.asistencia.comentario = '';
          }
          this.cdRef.markForCheck();
        }
      }, err => {
        console.error(err);
      }, () => {
      });
    }
  }

  setPermiso(checked, element) {
    element.asistencia.isPermiso = checked;
    if (!checked && element.asistencia.tipoID === 12) {
      element.asistencia.tipoID = 0
      this.deleteAsistencia(element);
    } else {
      element.asistencia.tipoId = element.asistencia.tipoId === 0 ? 12 : element.asistencia.tipoId;
      this.asistenciaService.setEstadoAsistencia(element.asistencia).subscribe(res => {
        element.asistencia = res['asistencia'];
      }, err => {
        console.error(err);
      }, () => {
      });
    }
  }

  setComentario(element) {
    if (this.subComment) {
      this.subComment.unsubscribe();
    }
    this.subComment = this.asistenciaService.setEstadoAsistencia(element.asistencia).subscribe(res => {
      this.cdRef.markForCheck();
    });
  }

  agregarAlumnos(vista) {
    this.throbberService.setThrobberState(true);
    this.reporteGeneralService.getListaAlumnos(this.fechaSeleccionada).subscribe(res => {
      this.throbberService.setThrobberState(false);
      const alumnos = res,
        dialogo = this.matDialogRef.open(ListaAlumnosComponent, {
          width: '100%',
          height: '100%',
          maxWidth: '100vw !important',
          maxHeight: 'calc(100vh - 64px)',
          position: { bottom: '0' },
          data: {
            alumnos,
            fecha: this.fechaSeleccionada,
            _tiposAsistencia: this.tipoAsistenciaPipe.transform(this.tiposAsistencia, ['R', 'A', 'PC']),
            tiposAsistencia: this.tiposAsistencia,
            vista
          },
          disableClose: true
        });
      const sub = dialogo.componentInstance.onCloseDialog.subscribe((registros) => {
        registros.map(registro => {
          this.reporteGeneralService.addStudent(registro);
        });
        dialogo.close();
      });
      dialogo.afterClosed().subscribe(() => {
        sub.unsubscribe();
      });
    }, err => {
      this.throbberService.setThrobberState(false);
      console.error(err);
    }, () => {
    });
  }

  updateFechas(asistencia) {
    asistencia.duracion = Math.round(
      moment.duration(moment(asistencia.fechaAsistenciaFin).diff(moment(asistencia.fechaAsistencia))).asDays());

    this.asistenciaService.setEstadoAsistencia(asistencia).subscribe(res => {
      const currAsistencia = this.asistenciaService.extractData(res);
      asistencia = currAsistencia.asistencia;
    });
  }
}
